import { useState } from 'react'

import { ConfirmInfoStage, type ConfirmInfoState } from '@/models/confirmInfo'
import type { FillCheck } from '@/models/fillApplication'
import type { EditedCard } from './confirmSteps'
import { ReviewCard } from './ReviewCard'
import { VerifyEmailCard } from './VerifyEmailCard'

interface ConfirmationStepProps {
  orgId: string
  state: ConfirmInfoState
  /** The checks still standing, past any the customer has just fixed. */
  checks: FillCheck[]
  /** Cards with unsaved edits, which confirming saves first. */
  edited: EditedCard[]
}

/** Certify, then prove the email when it isn't yet; the chat asked for the BOR before handing over. */
export function ConfirmationStep({ orgId, state, checks, edited }: ConfirmationStepProps) {
  // Confirming emails a code when the address isn't proven yet.
  const [codeSent, setCodeSent] = useState(false)

  return (
    <div className="flex flex-col gap-4">
      {state.stage === ConfirmInfoStage.VERIFY_EMAIL ? (
        <VerifyEmailCard orgId={orgId} email={state.email} codeSent={codeSent} edited={edited} />
      ) : (
        <ReviewCard
          orgId={orgId}
          applicationId={state.application?.id}
          checks={checks}
          edited={edited}
          onConfirmed={() => setCodeSent(true)}
        />
      )}
    </div>
  )
}
